

















import CookieConsent from './scripts';

export default CookieConsent;
